import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, mergeMap, switchMap } from 'rxjs/operators';
import { Observable, EMPTY } from 'rxjs';

import * as ReviewerInteractionActions from '../actions/reviewer-interaction.actions';
import { ReviewerInteractionsService } from '../services/reviewer-interactions.service';
import { ReviewerInteraction } from '@sleipai/sleip-models';
import { filterForUniqueInStringArray } from '../../helpers/unique.helper';
import { createChunksOfTen } from '../../helpers/chunks.helper';
import { UserActions } from '../../user-store';

@Injectable()
export class ReviewerInteractionEffects {
  loadReviewerInteractions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReviewerInteractionActions.loadReviewerInteractions),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => EMPTY as Observable<{ type: string }>)
    );
  });

  loadSingleReviewInteraction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReviewerInteractionActions.loadReviewInteractionById),
      mergeMap(({ id, uid }) => {
        return this.reviewerInteractionService.getReviewerInteractionsById(id).pipe(
          switchMap((interaction: ReviewerInteraction) => {
            const newInteraction: ReviewerInteraction = {
              recordingId: id,
              time: new Date(),
              interactions: [
                {
                  time: new Date(),
                  action: 'opened',
                  uid,
                },
              ],
            };
            if (interaction?.recordingId) {
              // Filter for unique uids.
              const uids = interaction.interactions.map((i) => i.uid);
              const uniqueUids = filterForUniqueInStringArray(uids);
              const chunks = createChunksOfTen(uniqueUids);
              // TODO: rebuild this!! FOR THE LOVE OF CHRIST REBUILD IT!
              return [
                UserActions.loadUsersByIds({ uids: chunks[0] }),
                ReviewerInteractionActions.addSingleReviewInteraction({ reviewActions: interaction }),
              ];
            } else {
              this.reviewerInteractionService.updateReviewerActionById(newInteraction);
              return [
                ReviewerInteractionActions.addSingleReviewInteraction({ reviewActions: newInteraction }),
              ];
            }
          })
        );
      })
    );
  });

  constructor(private actions$: Actions, private reviewerInteractionService: ReviewerInteractionsService) {}
}
